import { WorkOrder, Category, Candidate } from "./interfaces";
import ApiService from "../services/ApiService";

export async function listWorkOrders() {
  return ApiService.fetchData<WorkOrder[]>({
    url: "/andqo/workorder/",
    method: "get",
  });
}

export async function listCategories() {
  return ApiService.fetchData<Category[]>({
    url: "/andqo/category/",
    method: "get",
  });
}

export async function addCategory(categoryData: Record<string, unknown>) {
  return ApiService.fetchData<Category[]>({
    url: "/andqo/category",
    method: "post",
    data: categoryData,
  });
}

export async function deleteItem(item: string, itemId: string) {
  return ApiService.fetchData<any>({
    url: `/commun/${item}/${itemId}`,
    method: "delete",
  });
}

export async function UploadCsv(file: File) {
  const formData = new FormData();
  formData.append("file", file);

  return ApiService.fetchData<{ filename: string }>({
    url: "/sncf/upload",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }, true);
}

export async function listCandidates() {
  return ApiService.fetchData<Candidate[]>({
    url: "/sncf/status",
    method: "get",
  });
}

export async function getVerificationImage(imagePath: string) {
  return ApiService.fetchData<any>({
    url: `/sncf/image/${imagePath}`,
    method: "get",
    responseType: "blob",
  });
}